import logoPrimary from '../assets/brand/logo-horizontal-primary.svg';
import logoReversed from '../assets/brand/logo-horizontal-reversed.svg';

const LOCKUPS = {
  primary: logoPrimary,
  reversed: logoReversed,
};

/**
 * Approved horizontal Tu-Link lockup, used as supplied artwork.
 * Never recoloured, stretched, shadowed or re-typeset. The rendered width comes
 * through a custom property so layouts can respond without inline overrides.
 */
export const Logo = ({ variant = 'primary', width = 148, className = '', alt = 'Tu-Link' }) => (
  <img
    className={`tl-logo ${className}`.trim()}
    src={LOCKUPS[variant] || LOCKUPS.primary}
    alt={alt}
    width={2560}
    height={644}
    style={{ '--tl-logo-width': `${width}px` }}
    draggable="false"
  />
);
